export function CreativeCoalition({children}) {
    return (
        <>
            <div className="creative_coalition center_text">
                <img src="/logo_256x256.png" alt="Лого" className="logo"/>
                <h1>Творческая коалиция</h1>
                <p>
                    {children}
                </p>
            </div>
            <div className="line"/>
        </>
    )
}